<template>
  <div id="container">
    <div id="left" class="column"></div>
    <div id="center" class="column">
      <div style="padding: 20px; text-align: center">
        <el-button @click="onThree" type="primary">下载PDF</el-button>
      </div>
      <div class="header-row" id="pdfDom">
        <div style="height: 1421.42px">
          <div class="header-all" style="height: 1421.42px">
            <div class="tui-reportHeader">
              <img
                src="http://mushroomisand.oss-cn-shanghai.aliyuncs.com/images/2022-6/2022-6-23/20220623135937_1734.png?x-oss-process=style/imgset"
                style="width: 12rem; height: 100%"
                alt=""
                crossOrigin="anonymous"
              />
              <div
                style="
                  position: absolute;
                  top: -20px;
                  left: 0;
                  right: 0;
                  text-align: center;
                "
              >
                <div class="TenanName">{{ $route.query.SchoolName }}</div>
                <div class="tui-reportTitle">
                  幼儿主题评价（{{ $route.query.ClassName }}）
                </div>
              </div>
            </div>
            <div class="header-all-title">
              <div style="font-size: 25px; color: #fff; padding-bottom: 20px">
                {{ $route.query.StudyYearName }}届 {{ $route.query.GradeName }}
              </div>
              <div style="font-size: 25px; color: #fff">
                {{ $route.query.ClassName }}
                {{ $route.query.ChildrenName }}
              </div>
            </div>
          </div>
          <!-- <div class="header-all">
            <img
              :src="userImg.CoverImg + '?x-oss-process=style/imgset'"
              style="width: 100%; height: 100%; position: absolute; z-index: 0"
              crossorigin="anonymous"
              alt=""
            />
            <div class="header-all-title">
              <div class="tui-headerTitle" style="">
                {{ userInfo.SchoolName }}
              </div>
              <div class="tui-headerName">
                幼儿主题评价（{{ $route.query.ClassName }}）
              </div>
            </div>

            <div class="header-all-title" style="padding-top: 345px">
              <div style="font-size: 44px; font-weight: 500">
                {{ $route.query.StudyYearName }}届 {{ $route.query.GradeName
                }}{{ $route.query.ClassName }}
                {{ $route.query.ChildrenName }}
              </div>
            </div>
          </div> -->
        </div>
        <template v-if="subjectArr.length != 0">
          <div class="tui-Box" style="height: 1421.21px; padding: 0 30px">
            <div class="themeName">
              {{ $route.query.Title }}
            </div>

            <div v-for="(item, index) in subjectArr" :key="index">
              <div class="tui-subjectTitle" style="font-size: 36px">
                {{ item.Title }}：
              </div>
              <div
                class="tui-subjectTitle"
                style="white-space: pre-line; margin-top: -18px"
              >
                {{ item.Desc }}
              </div>
            </div>
          </div>
        </template>
        <!-- P1 -->
        <template v-for="(list, keys) in List">
          <div :key="keys" v-if="list.isShowKeyWord">
            <div
              class="tui-Box"
              style="height: 1421.21px; overflow: hidden; padding: 0 30px"
            >
              <div class="gradeBox">
                <div
                  class="evaluateTitle"
                  v-if="list.isShowKeyWord && keys == 0"
                >
                  {{ list.EvaluateTitle }}
                </div>
                <template v-for="(item, index) in list.KeyWordList">
                  <div
                    style="padding: 0 10px"
                    :key="index"
                    v-if="item.DescribeList.length != 0"
                    ref="isOverflow"
                  >
                    <div class="keyword" id="offsetTitle">
                      {{ item.KeyWord }}
                    </div>
                    <div class="table" style="margin: 0">
                      <div class="tableHeader row">
                        <div class="lineOne">描述</div>
                        <div class="lineTwo">需努力</div>
                        <div class="lineThere">较好</div>
                        <div class="lineFour">好</div>
                      </div>
                      <div
                        class="row"
                        v-for="(itemLine, indexLine) in item.DescribeList"
                        :key="indexLine"
                      >
                        <template>
                          <div class="lineOne">
                            {{ itemLine.Text }}
                          </div>
                          <div
                            class="lineTwo"
                            v-for="(itemStar, indexStar) in list.starInfo"
                            :key="indexStar"
                          >
                            <div
                              class="starBox"
                              v-for="(itemStarTwo, indexStarTwo) in itemStar"
                              :key="indexStarTwo"
                              @click="
                                scoreCheck(index, indexLine, itemStarTwo.Score)
                              "
                            >
                              <img
                                v-if="itemLine.Score >= itemStarTwo.Score"
                                src="../../assets/starActive.png"
                              />
                              <img v-else src="../../assets/star.png" />
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </div>
            <!-- P2 -->
          </div>
        </template>
        <div
          class="tui-Box"
          style="
            height: 1421.21px;
            padding: 0 30px;
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
          "
          v-if="imgList.length != 0"
        >
          <div
            v-for="(product, indexs) in imgList"
            :key="indexs"
            :style="{ width: indexs == 0 ? '100%' : '50%' }"
          >
            <div
              class="tui-Desc"
              v-if="product.ImgList.length != 0 || product.Text != ''"
            >
              <div class="desc-title" style="text-align: center">
                {{ product.Title }}
              </div>
              <div
                class="tui-imgs"
                style="margin: 0 auto"
                v-if="product.ImgList.length != 0 && product.QuestionType != 3"
              >
                <img
                  :src="imgs + '?x-oss-process=style/imgset'"
                  style=""
                  class="img"
                  v-for="(imgs, ins) in product.ImgList"
                  :key="ins"
                  crossorigin="anonymous"
                />
                <div
                  class="img"
                  v-for="(item, index) in indexs == 0
                    ? 6 - product.ImgList.length
                    : indexs == 1
                    ? 2 - product.ImgList.length
                    : 1 - product.ImgList.length"
                  :key="index"
                ></div>
              </div>
              <div
                v-if="product.ImgList.length == 0 && product.QuestionType != 3"
                class="tui-imgs"
                style="margin: 0 auto"
              >
                <div
                  class="img"
                  v-for="(item, index) in indexs == 0 ? 6 : indexs == 1 ? 2 : 1"
                  :key="index"
                ></div>
              </div>
              <div class="tui-writing" v-if="product.Text">
                {{ product.Text }}
              </div>
            </div>
          </div>
        </div>
        <!-- 幼儿报告 -->

        <div>
          <img
            :src="userImg.BackCoverImg"
            alt=""
            crossorigin="anonymous"
            style="height: 100%; width: 100%"
          />
        </div>
      </div>
    </div>
    <div id="right" class="column"></div>
  </div>
</template>
<script>
import {
  GetBabyEval_ThemeDetail,
  GetCoverImgByThemeId,
  GetThemeDesc,
} from "../../api/api";
import html2Canvas from "html2canvas";
import JsPDF from "jspdf";

export default {
  data() {
    return {
      List: [],
      imgList: [],
      userImg: {},
      // userInfo: {},
      subjectArr: [],
    };
  },
  created() {
    // this.userInfo = JSON.parse(window.localStorage.user);
    this.GetCoverImgByThemeId();
    this.GetBabyEval_ThemeDetail();
    this.GetThemeDesc();
  },
  methods: {
    async GetThemeDesc() {
      let res = await GetThemeDesc({ ThemeId: this.$route.query.ThemeId });
      if (res.data.success) {
        this.subjectArr = res.data.response;
      }
    },
    uq(array) {
      //将array数组转换成set对象,再使用Array.from()方法将set对象转换成数组
      return Array.from(new Set(array));
    },
    // 获取封面封底
    GetCoverImgByThemeId() {
      GetCoverImgByThemeId({ Id: this.$route.query.ThemeId }).then((res) => {
        if (res.data.success) {
          this.userImg = res.data.response;
        }
      });
    },
    // 获取报告
    GetBabyEval_ThemeDetail() {
      const params = {
        StudentId: this.$route.query.CustomerId,
        ThemeId: this.$route.query.ThemeId,
        ThemeMapId: this.$route.query.ThemeMapId,
      };
      GetBabyEval_ThemeDetail(params).then((res) => {
        if (res.data.success) {
          for (let i = 0; i < res.data.response.length; i++) {
            let item = res.data.response[i];
            item.secondDescResults.forEach((element) => {
              element.ImgList = element.ImgList.filter((item) => {
                return item;
              });
            });
            if (item.IsRead) {
              this.imgList.push(...item.secondDescResults);
            }

            // 获取星星评分的结构
            item.starInfo = this.distinguish(item.Type);
            // 判断是否有评分题
            let isShowKeyWord = false;
            // for (let j = 0; j < item.KeyWordList.length; j++) {
            //   // 删选出分数为0的
            //   item.KeyWordList[j].DescribeList = item.KeyWordList[
            //     j
            //   ].DescribeList.filter((itemFilter) => {
            //     return itemFilter.Score != 0;
            //   });
            // }
            for (let j = 0; j < item.KeyWordList.length; j++) {
              // 存在一项评分题即存在
              if (item.KeyWordList[j].DescribeList.length != 0) {
                isShowKeyWord = true;
                break;
              }
            }
            item.isShowKeyWord = isShowKeyWord;
          }
          this.List = res.data.response;

          //console.log(this.List);
        } else {
          this.$message({
            type: "error",
            message: res.data.msg,
          });
        }
      });
    },
    /**
     * 区分三星还是9星
     * @param {Object} Type 1是9星版本 2是三星版本
     */
    distinguish(Type) {
      let starInfo = [];
      // 三个子数组对应是哪个分数的单元格 子数组中的对象代表一个星星信息 score选择获得的分数
      if (Type == 1) {
        starInfo = [
          [
            {
              Score: 1,
            },
            {
              Score: 2,
            },
            {
              Score: 3,
            },
          ],
          [
            {
              Score: 4,
            },
            {
              Score: 5,
            },
            {
              Score: 6,
            },
          ],
          [
            {
              Score: 7,
            },
            {
              Score: 8,
            },
            {
              Score: 9,
            },
          ],
        ];
      } else {
        starInfo = [
          [
            {
              Score: 1,
            },
          ],
          [
            {
              Score: 2,
            },
          ],
          [
            {
              Score: 3,
            },
          ],
        ];
      }
      return starInfo;
    },
    onThree() {
      // 获取高度值 （内容高+padding+边框）
      // let Box = this.$refs.isOverflow;
      // let Title = document.getElementById("offsetTitle");
      // //console.log(Title);
      // var x = 108;
      // //console.log(Box);
      // for (let index = 0; index < Box.length; index++) {
      //   const element = Box[index];
      //   //console.log(element.offsetHeight); //获取到每个子元素的高度
      //   x += element.offsetHeight;
      //   if (isNaN(x)) {
      //     return 0;
      //   }
      //   //console.log(x); //获取到高度总和
      // }
      const loading = this.$loading({
        lock: true,
        text: "正在下载PDF",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        let top = document.getElementById("pdfDom");
        if (top != null) {
          top.scrollIntoView();
          top = null;
        }
        var content = document.querySelector("#pdfDom");
        html2Canvas(content, {
          useCORS: true,
          scale: 3, // 提升画面质量，但是会增加文件大小
        }).then((canvas) => {
          var contentWidth = canvas.width;
          var contentHeight = canvas.height; //一页pdf显示html页面生成的canvas高度;
          var pageHeight = (contentWidth / 592.28) * 841.89; //未生成pdf的html页面高度
          var leftHeight = contentHeight; //页面偏移
          //console.log(pageHeight, leftHeight, "pageHeight");
          var position = 0; //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
          var imgWidth = 595.28;
          var imgHeight = (592.28 / contentWidth) * contentHeight;

          var pageData = canvas.toDataURL("image/jpeg", 1.0);

          var pdf = new JsPDF("", "pt", "a4"); //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89) //当内容未超过pdf一页显示的范围，无需分页
          if (leftHeight < pageHeight) {
            pdf.addImage(pageData, "JPEG", 0, 0, imgWidth, imgHeight);
          } else {
            // 分页
            while (leftHeight > 0) {
              pdf.addImage(pageData, "JPEG", 0, position, imgWidth, imgHeight);
              leftHeight -= pageHeight;
              position -= 841.89; //避免添加空白页
              if (leftHeight > 0) {
                pdf.addPage();
              }
            }
          }
          pdf.save(`${this.$route.query.ChildrenName}主题报告.pdf`);
          loading.close();
        });
      }, 300);
    },
  },
};
</script>
<style lang="less" scoped>
.tui-Box {
  background: url(../../assets/SubjectResult-bg.png) no-repeat center center;
  background-size: cover;
  align-content: flex-start;
}
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.tui-subjectName {
  font-size: 16px;
  color: #333;
  font-weight: 500;
  padding: 20px 0;
}
.themeName {
  text-align: center;
  font-size: 30px;
  padding-top: 50px;
}

.tui-Desc {
  padding: 0 10px;
  .desc-title {
    font-size: 36px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    padding: 18px 0;
  }
  .tui-father {
    display: flex;
    justify-content: space-between;
    .tui-imgContent:nth-child(2) {
      margin-left: 20px;
    }
  }
  .tui-imgs {
    max-width: 700px;
    // height: 400px;
    display: flex;
    justify-content: center;
    margin: 0 auto;
    flex-wrap: wrap;
    // justify-content: space-between;
    .img {
      margin-right: 15px;
      margin-bottom: 15px;
      width: 180px;
      background-color: #f1f2f7;
      height: 180px;
      object-fit: cover;
    }

    .img:nth-child(3n + 3) {
      margin-right: 0;
    }
    .img:last-child {
      margin-right: 0;
    }
  }
  .tui-writing {
    font-size: 18px;
    font-family: "font";
    font-weight: 400;
    color: #333333;
    line-height: 22px;
    min-height: 180px;
  }
}
.tui-subjectTitle {
  font-size: 18px;
  font-family: "font";
  font-weight: 400;
  color: #333333;
  line-height: 22px;
  padding: 20px 0;
}
.gradeBox {
  width: 100%;

  // box-shadow: 0px 4px 32px 3px rgba(57, 87, 181, 0.15);
  margin: 0 auto;

  .evaluateTitle {
    text-align: center;
    font-size: 40px;
    font-weight: 400;
    color: #333333;
    text-align: center;
    padding: 0 30px;
    padding-top: 33px;
    border-bottom: 1px solid #cdcdcd;
    padding-bottom: 22px;
  }

  .keyword {
    text-align: center;
    line-height: 64px;
    font-size: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #305a9f;
    font-weight: 500;
  }

  .table {
    .tableHeader {
      border-top: 1px solid #cdcdcd;

      view {
        color: #000000 !important;
      }

      .lineOne {
        padding: 10px 0;
        width: 300px;
        text-align: center;
        font-size: 22px;
      }
    }

    .row {
      display: flex;
      border-bottom: 1px solid #cdcdcd;

      img {
        width: 27px;
        height: 26px;
      }

      .starBox {
        padding: 0px;
      }

      view {
        padding: 10px;
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 300;
        color: #666666;
      }

      .lineOne {
        padding: 10px;
        width: 470px;
        border-right: 1px solid #cdcdcd;
        border-left: 1px solid #cdcdcd;
        font-size: 20px;
      }

      .lineTwo {
        flex: 1;
        text-align: center;
        border-right: 1px solid #cdcdcd;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 22px;
      }

      .lineThere {
        flex: 1;
        text-align: center;
        border-right: 1px solid #cdcdcd;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 22px;
      }

      .lineFour {
        flex: 1;
        text-align: center;
        display: flex;
        justify-content: space-around;
        align-items: center;
        font-size: 22px;
        border-right: 1px solid #cdcdcd;
      }
    }
  }
}
.header-all {
  height: 100%;
  background: url(../../assets/newBG.png) no-repeat center center;
  background-size: 100% 100%;
  position: relative;
  .tui-reportHeader {
    width: 100%;
    margin: 0 auto;
    position: absolute;
    top: 190px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .TenanName {
      font-size: 40px;
      color: #fff;
    }
    .tui-reportTitle {
      font-size: 60px;
      color: #fff;
      padding-top: 20px;
    }
    .tui-class {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 20px;

      span {
        width: 0.225rem;
        height: 0.225rem;
        border-radius: 50%;
        background: #ffec8e;
      }
      div {
        font-size: 0.375rem;
        color: #ffec8e;
        font-weight: 600;
        letter-spacing: 0.0625rem;
        padding: 0 0.25rem;
      }
    }
  }
  .header-Name {
    text-align: center;
    text-shadow: 0px 6px 1px #fff;
    font-size: 70px;
    font-family: Lantinghei SC;
    font-weight: 800;
    color: #3ec53f;
    padding-top: 111px;
  }
  .tui-headerName {
    font-size: 73px;
    font-weight: bold;
    text-align: center;
    color: #4f6585;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 60px;
  }
  .tui-headerTitle {
    width: 717px;
    height: 184px;
    font-size: 84px;
    font-weight: bold;
    text-align: center;
    color: #4f6585;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .header-all-title {
    position: absolute;
    bottom: 43px;
    left: 0;
    right: 0;

    display: flex;
    align-items: center;
    flex-direction: column;
  }
}
#header,
#footer {
  background: rgba(29, 27, 27, 0.726);
  text-align: center;
  height: 60px;
  line-height: 60px;
}
#container {
  background: #fff;
  display: flex;
}
#container .column {
  height: 100%;
  /* line-height: 300px; */
}
#center {
  width: 1000px;
  background: #fff;
}
#left {
  flex: 1;
}
#right {
  flex: 1;
}
.textOverflow {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>